<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>提现记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content">
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请选择coinType" clearable>
          <el-option
            v-for="item in coinList"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <el-select v-model="txStatus" placeholder="请选择txStatus" clearable>
          <el-option
            v-for="item in txStatusOption"
            :key="item.value"
            :label="item.lable"
            :value="item.value"
          ></el-option>
        </el-select>
        <!-- <el-select v-model="txDepositStatus" placeholder="请选择txDepositStatus">
          <el-option v-for="item in coinList" :key="item" :label="item" :value="item"></el-option>
        </el-select> -->
        <el-input placeholder="请输入用户Id" v-model="userId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="合伙人UID" v-model="channelUserId" clearable>
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入转入钱包地址"
          v-model="walletAddres"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>

        <el-date-picker
          v-model="value1"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          value-format="timestamp"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="changeTime($event)"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <el-select
          v-model="onlyChannel"
          placeholder="合伙人筛选"
          clearable
          @clear="selectClear"
          @change="selectChange"
        >
          <el-option
            v-for="item in partnerArr"
            :key="item.val"
            :label="item.label"
            :value="item.val"
          ></el-option>
        </el-select>
        <el-input
          placeholder=""
          v-model="inputUid"
          v-if="onlyChannel == -100"
          clearable
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <!-- <span>待查询的Hash值为：{{hash}}</span> -->
      </div>
      <div class="pl_total_box">
        <div class="pl_total">
          <span>提现汇总</span>
          <span></span>
          <span>{{ totalInfo | fixD(6) }}</span>
          <!-- <span>USDT</span> -->
        </div>
        <!-- <div class="pl_total">
          <span>总计盈亏</span>
          <span></span>
          <span>{{ totalRealizedProfit | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
        <!-- <div class="pl_total">
          <span>持仓手续费汇总</span>
          <span></span>
          <span>{{ totalFee | fixD(6) }}</span>
          <span>USDT</span>
        </div> -->
      </div>
      <audit-list @refresh="refreshList($event)"></audit-list>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapState, mapActions, mapMutations } from "vuex";
import AuditList from "./components/list";
import moment from "moment";
import { transformTime } from "../../../utils/formatTime";
export default {
  name: "loglim",
  data() {
    return {
      partnerArr: [
        { label: "仅查询合伙人", val: -1 },
        { label: "合伙人UID", val: -100 },
      ],
      onlyChannel: "",
      inputUid: "",
      coinType: "",
      userId: "",
      channelUserId: "",
      txStatus: "",
      walletAddres: "",
      value1: [],
      // value1: [
      // moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     '-' +
      //     (new Date().getMonth() + 1) +
      //     '-' +
      //     new Date().getDate(),
      // ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      txStatusOption: [
        { lable: "已经确认", value: 0 },
        { lable: "已提交", value: 1 },
        { lable: "取消", value: 2 },
        { lable: "失败", value: -1 },
        { lable: "确认中", value: 3 },
        { lable: "已审核", value: 4 },
        { lable: "区块链网络已经发送， 等待确认中", value: 5 },
        { lable: "系统错误", value: 6 },
        { lable: "管理员退回", value: 7 },
        { lable: "余额变更异常", value: 9 },
      ],
    };
  },
  components: {
    AuditList,
  },
  computed: {
    ...mapState("withrawRecord", ["pagination", "coinList", "totalInfo"]),
    ...mapState("mining", ["coinTypeList"]),
  },
  methods: {
    ...mapActions("withrawRecord", [
      "gethashList",
      "getAllCoins",
      "getTotalInfo",
    ]),
    ...mapActions("mining", ["getCoinTypeList"]),
    ...mapMutations("withrawRecord", ["setpage"]),
    changeTime(e) {
      this.gethashList({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        ...this.pagination,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
      this.getTotalInfo({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
    },
    refreshList(data = {}) {
      this.gethashList({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        //  ...this.pagination,
        ...data,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
      this.getTotalInfo({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
    },
    handleSearch() {
      // let coin = this.$route.query.coin;
      // let toAddress = this.$route.query.toAddress;
      // if (coin&&toAddress) {
      this.setpage = { ...this.pagination, page: 1 };
      this.gethashList({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...this.pagination,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        page: 1,
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
      this.getTotalInfo({
        type: 2,
        coinType: this.coinType,
        userId: this.userId,
        channelUserId: this.channelUserId,
        txStatus: this.txStatus,
        walletAddres: this.walletAddres,
        ...transformTime({
          startTime: "startTime",
          endTime: "endTime",
          startTimeNUmber: this.value1[0] || "",
          endTimeNUmber: this.value1[1] || "",
        }),
        onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      });
      // } else {
      //   this.$message.error("币种和地址不能为空");
      //   return;
      // }
    },
    selectClear() {
      this.inputUid = "";
    },
    selectChange() {
      this.inputUid = "";
    },
  },
  mounted() {
    const query = this.$route.query;
    for (const key in query) {
      this[key] = query[key];
    }

    this.gethashList({
      type: 2,
      coinType: this.coinType,
      userId: this.userId,
      channelUserId: this.channelUserId,
      txStatus: this.txStatus,
      walletAddres: this.walletAddres,
      ...this.pagination,
      onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
      page: 1,
    });
    this.getTotalInfo({
      type: 2,
      coinType: this.coinType,
      userId: this.userId,
      channelUserId: this.channelUserId,
      txStatus: this.txStatus,
      walletAddres: this.walletAddres,
      onlyChannel: this.onlyChannel == -1 ? this.onlyChannel : this.inputUid,
    });
    this.getCoinTypeList();
    this.getAllCoins();
  },
};
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>

<style lang="less" scoped>
.page-actions > .el-input {
  width: 200px;
  min-width: unset;
}
</style>
